export default {
    namespaced: true,

    state: {
        isNotification: false,
        count: 0,
        messages: []
    },
    getters: {},
    mutations: {
        setIsNotification (state, value) {
            state.isNotification = value;
        },
        setRead (state, value) {
            state.messages[value].isRead = true;
            state.count--;
        },
        setDelete (state, value) {
            state.messages[value].isDelete = true;
            state.count--;
        },
        setAllRead (state) {
            const notificationBox = document.getElementById('kona-notification');
            notificationBox.childNodes.forEach(element => element.childNodes[0].click())
            state.count = 0;
        },
        setAllDelete (state) {
            const notificationBox = [...document.getElementById('kona-notification').childNodes].reverse();
            notificationBox.forEach(element => {
                element.childNodes[2].click()
            })
            state.count = 0;
        }
    },
    actions: {
        setMessage ({state, dispatch}, value) {
            let tempMessage = {
                id: state.messages.length,
                deviceid: value.deviceid,
                message: value.message,
                isRead: false,
                isDelete: false,
                time: value.time
            };

            if (state.isNotification) dispatch('addNotificationBox', tempMessage);
            state.messages.push(tempMessage);
            state.count++;
        },
        addNotificationBox ({commit}, element) {
            if (element.isDelete) return;

            const notificationBox = document.getElementById('kona-notification');

            const messageBox = document.createElement('div');
            messageBox.className = 'd-flex';
            messageBox.id = 'message'
            messageBox.style.height = '50px';
            messageBox.style.borderStyle = 'solid';
            messageBox.style.borderWidth = 'thin thin thin thin';
            messageBox.style.borderColor = '#2c3e50';
            messageBox.style.backgroundColor = 'white';
            messageBox.style.color = element.isRead ? 'gray' : 'black';

            const textBox = document.createElement('div');
            textBox.className = 'w-75'
            textBox.innerText = element.id + ' ' + element.message;
            textBox.onclick = () => {
                commit('setRead', element.id);
                messageBox.style.color = 'gray'
            }

            const timeBox = document.createElement('div');
            timeBox.className = 'w-25'
            timeBox.innerText = element.time;
            timeBox.onclick = () => {
                commit('setRead', element.id);
                messageBox.style.color = 'gray'
            }

            const closeBox = document.createElement('button');
            closeBox.type = 'button';
            closeBox.className = 'btn-close';
            closeBox.onclick = () => {
                commit('setDelete', element.id);
                messageBox.remove();
            }

            messageBox.appendChild(textBox);
            messageBox.appendChild(timeBox);
            messageBox.appendChild(closeBox);
            notificationBox.prepend(messageBox);
        },
    },
    modules: {}
}